import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { DecimalPipe } from "@angular/common";
import { SurveysRoutingModule, routedComponents } from "./surveys-routing.module";
import { EasyFormsModule } from "../core/easy-forms/easy-forms.module";
import { ChartModule, SharedModule as SharedModulePng, } from "primeng/primeng";

@NgModule({
  imports: [
    SharedModule,
    SurveysRoutingModule,
    EasyFormsModule,
    ChartModule,
    SharedModulePng
  ],
  declarations: [
    routedComponents],
  providers: []
})
export class SurveysModule { }



// WEBPACK FOOTER //
// ./src/app/surveys/surveys.module.ts